import { type EffectCallback, useEffect } from 'react';

/**
 * 컴포넌트가 마운트될 때 실행되는 훅
 * @param cb - 마운트 시 실행할 콜백 함수
 */
const useMount = (cb: EffectCallback) => {
  /*  eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    return cb();
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */
};

export default useMount;
